import { createStyles, Grid, makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import repeat from '../helpers/repeat';

export interface TableSkeletonProps {
    columns: number;
}

const useStyles = makeStyles(() => createStyles({
    head: {
        marginBottom: 0,
    },
    columnHeading: {
        borderRadius: 4,
        height: '1.7rem',
    },
    body: {
        borderRadius: 4,
        height: 400,
        width: '100%',
    },
    skeleton: {
        backgroundColor: '#EEF3F9',
    },
}));

const TableSkeleton: FunctionComponent<TableSkeletonProps> = (
    { columns: columnCount },
) => {
    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={4} className={classes.head}>
                {
                    repeat(columnCount, iteration => (
                        <Grid key={iteration} item xs>
                            <Skeleton
                                animation="wave"
                                variant="rect"
                                className={clsx(classes.columnHeading, classes.skeleton)}
                            />
                        </Grid>
                    ))
                }
            </Grid>

            <Skeleton
                animation="wave"
                variant="rect"
                className={clsx(classes.body, classes.skeleton)}
            />
        </div>
    );
};

export default TableSkeleton;
